module.exports = __webpack_public_path__ + "img/greentick.a7f9ac95.svg";